/**
 * 鼠标右键动画
 */
import fvAnimation from "./fvAnimation"
export default class fvRmousescript extends fvAnimation {
    constructor(shape){
        super(shape,"fvRmousescript");
        this.rmouseDownFunction = null;
        this.rmouseUpFunction = null;
        this.rmouseDbClickFunction = null;
        this.rmouseTimerUnitFunc = null;
        try{
          this.rmouseDownFunction = AsyncFunction(this.rmousedownscript);
          this.rmouseUpFunction = AsyncFunction(this.rmouseupscript);
          this.rmouseDbClickFunction = AsyncFunction(this.rmousedbscript);
          this.rmouseTimerUnitFunc = AsyncFunction(this.rtimerscript);
        }catch(e){
          console.error(e)
        }
        this.timer = null;
        this.timeOut = null;
        this.timeUp = null;
        this.rmouseTimerFunction = function(){
            clearTimeout(this.timeOut);
            this.executionScript(this.rmouseTimerUnitFunc);
            this.timer = setTimeout(this.rmouseTimerFunction,this.rtimer);
        }.bind(this);
        this.lastTime = 0;
    }

    run(event,value){
        if(value == false) return;
        if(!this.shape.mouseState){
            return;
        }
        this.action(event);
        super.run();
    }

    async action(event){
        if("down" === this.getEventType(event.type)){
            var currTime = new Date().getTime();
            clearTimeout(this.timer);
            clearTimeout(this.timeOut);
            if(currTime - this.lastTime >= this.rtimer){
                this.rmouseTimerFunction();
            }

            // 判断鼠标点击小于300ms 双击
            if(currTime - this.lastTime < 300){
                clearTimeout(this.timeOut);
                clearTimeout(this.timeUp);
                this.executionScript(this.rmouseDbClickFunction);
            }else{
                clearTimeout(this.timeOut);
                clearTimeout(this.timeUp);
                this.timeOut = setTimeout(function() {
                    this.executionScript(this.rmouseDownFunction);
                }.bind(this),300);
            }
            this.lastTime = currTime;
        }else if("up" === this.getEventType(event.type)){
            // 鼠标抬起清楚周期执行
            clearTimeout(this.timer);
            this.timeUp = setTimeout(function() {
                this.executionScript(this.rmouseUpFunction);
            }.bind(this),300);
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvRmousescript.js